
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BankCardOrder"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankCardOrder"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failureReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardOrderStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressVerification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"identityVerification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentUploadUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRetry"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"prefundVerification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingSourceVerification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pendingReason"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundingInitiated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bankCardTier"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReopenable"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":523}};
    doc.loc.source = {"body":"query BankCardOrder {\n  bankCardOrder {\n    failureReason\n    cardOrderStatus\n    addressVerification {\n      status\n      actionRequired\n    }\n    identityVerification {\n      status\n      actionRequired\n      documentUploadUrl\n      canRetry\n    }\n    prefundVerification {\n      status\n      actionRequired\n    }\n    fundingSourceVerification {\n      status\n      actionRequired\n      pendingReason\n    }\n    kycStatus\n    fundingInitiated\n    requestVersion\n    bankCardTier\n  }\n  spendAccount {\n    isReopenable\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BankCardOrder"] = oneQuery(doc, "BankCardOrder");
        
